import { createFileRoute } from '@tanstack/react-router';
import AuthGuard from '@/components/auth-guard';
import { FixedExpensesManager } from '@/components/financial/fixed-expenses-manager';
import { RecurringList } from '@/components/recurring/recurring-list';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

export const Route = createFileRoute('/fixed-expenses')({
  component: FixedExpensesPage,
});

function FixedExpensesPage() {
  return (
    <AuthGuard requireAuth={true}>
      <div className="container mx-auto space-y-6 px-4 py-6">
        <div>
          <h1 className="font-bold text-2xl tracking-tight">
            Gastos Fixos
          </h1>
          <p className="text-muted-foreground">
            Gerencie seus gastos fixos mensais e compare com sua renda
          </p>
        </div>

        <Tabs defaultValue="overview" className="space-y-6">
          <TabsList>
            <TabsTrigger value="overview">Visão Geral</TabsTrigger>
            <TabsTrigger value="manage">Gerenciar Recorrentes</TabsTrigger>
          </TabsList>

          <TabsContent value="overview" className="space-y-6">
            <FixedExpensesManager />
          </TabsContent>

          <TabsContent value="manage" className="space-y-6">
            <RecurringList showInactive={true} />
          </TabsContent>
        </Tabs>
      </div>
    </AuthGuard>
  );
}
